import { css, unsafeCSS } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { BaseComponent } from '@src/components/BaseComponent.js';
import styles from '@src/components/TefComsLoader.css' with { type: 'text' };

@customElement('tef-coms-loader')
export class TefComsLoader extends BaseComponent {
  @property({ type: Boolean }) cloak : boolean = false;

  static readonly styles = css`${unsafeCSS(styles)}`;

  override render() {
    return this.getTemplateFn('tefComsLoader')();
  }
}
